export default __webpack_public_path__ + "ubisoft-playtest-profile-mobile-steps-1-4.webp";